export default __webpack_public_path__ + "static/media/01 Marketing - Floor Plan by Type 8.7f281d84.jpeg";